<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-mb-vals-card" v-if="this.valuesList.length != 0">
    <v-data-table
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      :mobile-breakpoint="0"
      item-key="cd"
      hide-default-footer
      disable-sort
      disable-filtering
      fixed-header
      height="100%"
      dense
      class="tm-mb-detail-stage-values-tbody"
    >
    >
      <template v-slot:[`item.snwdp`]="{ item }">
        <span
          v-if="showSnowHighlight(item.snwdp)"
          class="tm-mb-detail-snow-color-highlight"
          :rw-info-color="setSnowInfoColor(item.snwdp)"
        >
          {{ item.snwdp }}
        </span>
        <span v-else> {{ item.snwdp }} </span>
      </template>
    </v-data-table>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]積雪 観測値カード
 * TmSnowValues.vue
 * @author ILUKE
 */

export default {
  name: "tm-snow-values",
  data() {
    return {};
  },
  computed: {
    /**
     * 表示時刻設定(0:時間単位、1:10分単位) 取得
     */
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      }
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        return this.hourList.headers;
      }
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        // 時間単位
        return this.hourList.values;
      }
    },
    /**
     * 海岸情報(時間) 取得
     */
    hourList: {
      get() {
        return this.$store.state.Telemeter.selectedTm.obsValues.hour;
      }
    }
  },
  methods: {
    /**
     * 超過観測所 着色
     */
    setSnowInfoColor(snwdp) {
      if (snwdp <= 5){
        return "snwNormal";
      } else if (snwdp <= 20){
        return "snwLevel0";
      } else if (snwdp <= 50){
        return "snwLevel1";
      } else if (snwdp <= 100){
        return "snwLevel2";
      } else if (snwdp <= 150){
        return "snwLevel3";
      } else if (snwdp <= 200){
        return "snwLevel4";
      } else if (200 < snwdp){
        return "snwLevel5";
      }
    },
    /** 強調表示するか */
    showSnowHighlight(snwdp) {
      if (snwdp > 0){
        return true;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
</style>